import React, {
  memo,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import {
  Button,
  CheckBox,
  DataGrid,
  NumberBox,
  SelectBox,
  Template,
  TextBox,
} from "devextreme-react";
import {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
} from "devextreme-react/data-grid";
import { DateFormat, RegEx, StatusType } from "../../helpers/fixcodes";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import RadioGroup from "devextreme-react/radio-group";
import { showResponseMessage } from "../../helpers/message";
import CrewActivityCodeComponent from "./CrewActivityCodeComponent";
import { axiosGet, axiosPost } from "../../apis/useAxios";
const airlineTypeLst = [
  { id: 1, text: "Domestic" },
  { id: 2, text: "International" },
  { id: 3, text: "Both" },
];
export default function NonFlyTransportMatrixComponent() {
  const [state, setState] = useState({
    nonFlyActivityTransMatrixGridDataSource: [],
    openTransMatrixModal: false,
    transMatrix: {
      id: 0,
      activityTypeName: "",
      cockpitCrewTransportAtBase: false,
      cockpitCrewTransportOutsideBase: false,
      cabinCrewTransportAtBase: false,
      cabinCrewTransportOutsideBase: false,
    },
    isTransMatrixSubmitted: false,
    viewActivityCodes: {
      openModal: false,
      activityTypeId: 0,
      activityTypeName: "",
    },
  });
  const refDataGrid = useRef(null);
  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML =
      `Crew - Non Fly Transport Matrix`;
  }, []);
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetGridDataOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);
  const fetGridDataOnPageLoad = () => {
    try {
      setTimeout(async () => {
        await getCrewNonFlyActivityTransMatrixList();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  const getCrewNonFlyActivityTransMatrixList = async () => {
    try {
      refDataGrid.current.instance.beginCustomLoading();
      let apiUrl = `${
        process.env.REACT_APP_API_BASE_URL
      }CrewActivity/${sessionStorage.getItem(
        "session_airlineCode",
      )}/non-fly-activity-trans-matrix`;
      const response = await axiosGet(
        `CrewActivity/${sessionStorage.getItem(
          "session_airlineCode",
        )}/non-fly-activity-trans-matrix`,
      );
      setState((prev) => ({
        ...prev,
        nonFlyActivityTransMatrixGridDataSource: response?.payload ?? [],
      }));
      // refDataGrid.current.instance.refresh();
      // refDataGrid.current.instance.repaint();
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid.current.instance.endCustomLoading();
    }
  };
  const handleOnSubmitActivityTransMatrix = async () => {
    try {
      let msg = `Are you sure want to update transport matrix.<br/>Activity: [ <strong>${state.transMatrix.activityTypeName} ] </strong>`;
      const isConfirm = await confirmMsg("edit", msg);
      if (isConfirm) {
        setState((prev) => ({ ...prev, isTransMatrixSubmitted: true }));
        const request = {};
        request.AirlineCode = sessionStorage.getItem("session_airlineCode");
        request.CockpitCrewTransportAtBase =
          state.transMatrix.cockpitCrewTransportAtBase;
        request.CockpitCrewTransportOutsideBase =
          state.transMatrix.cockpitCrewTransportOutsideBase;
        request.CabinCrewTransportAtBase =
          state.transMatrix.cabinCrewTransportAtBase;
        request.CabinCrewTransportOutsideBase =
          state.transMatrix.cabinCrewTransportOutsideBase;
        request.UserName = sessionStorage.getItem("session_userName");
        const response = await axiosPost(
          `CrewActivity/${state.transMatrix.id}/non-fly-activity-trans-matrix-update`,
          request,
        );
        setState((prev) => ({ ...prev, isTransMatrixSubmitted: false }));
        if (response?.isSuccess) {
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: response?.message,
            allowOutsideClick: false,
          }).then(async (result) => {
            if (result.isConfirmed) {
              setState((prev) => ({
                ...prev,
                openTransMatrixModal: false,
              }));
              await getCrewNonFlyActivityTransMatrixList();
            }
          });
        } else {
          toast.error(response?.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            closeButton: false,
          });
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isTransMatrixSubmitted: false }));
      console.log(error);
    }
  };
  const confirmMsg = async (type, msg, title) => {
    let isResult = false;
    let confirmMessage = "";
    if (type === "delete") {
      if (msg !== "") {
        confirmMessage =
          "Are you sure want to delete this address <b>" + msg + "</b>?";
      } else {
        confirmMessage = "Are you sure want to delete this address?";
      }
    } else if (type === "status") {
      confirmMessage = msg;
    } else if (type === "add") {
      confirmMessage = msg;
    } else if (type === "edit") {
      confirmMessage = msg;
    }
    await Swal.fire({
      title: title,
      html: "<small>" + confirmMessage + "</small>",
      icon: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText:
        type === "delete"
          ? "Delete"
          : type === "add"
            ? "Add"
            : type === "edit"
              ? "Update"
              : title,
    }).then(async (result) => {
      if (result.isConfirmed) {
        isResult = true;
      }
    });
    return isResult;
  };
  const renderTransMatrixGridCell = (data) => {
    let openActivityTransMatrixLink = (
      <a
        href="#"
        title="Set Activity Transport Matrix"
        onClick={(e) => {
          e.preventDefault();
          let transMatrix = state.transMatrix;
          transMatrix.id = data.data.rowIndex;
          transMatrix.activityTypeName = data.data.activityTypeName;
          transMatrix.cockpitCrewTransportAtBase =
            data.data.cockpitCrewTransportAtBase;
          transMatrix.cockpitCrewTransportOutsideBase =
            data.data.cockpitCrewTransportOutsideBase;
          transMatrix.cabinCrewTransportAtBase =
            data.data.cabinCrewTransportAtBase;
          transMatrix.cabinCrewTransportOutsideBase =
            data.data.cabinCrewTransportOutsideBase;
          setState((prev) => ({
            ...prev,
            openTransMatrixModal: true,
            transMatrix: transMatrix,
          }));
        }}
        className="btn-link"
      >
        <i style={{ cursor: "pointer" }} className="fas fa-edit"></i>
      </a>
    );
    let viewActivityCodeLink = (
      <a
        href="#"
        title="Update"
        onClick={(e) => {
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            viewActivityCodes: {
              openModal: true,
              activityTypeId: data.data.rowIndex,
              activityTypeName: data.data.activityTypeName,
            },
          }));
        }}
        className="btn-link"
      >
        <i style={{ cursor: "pointer" }} className="fas fa-tasks"></i>
      </a>
    );
    return (
      <div style={{ textAlign: "left" }}>
        {openActivityTransMatrixLink}
        {viewActivityCodeLink}
      </div>
    );
  };
  return (
    <>
      <style>{`
        /* ── Non Fly Transport Matrix — theme matching sidebar #fff0e6 ── */
        .ca-grid-wrap .dx-header-row td {
          background-color: #fff0e6 !important;
          color: #000000 !important;
          font-size: 0.76rem !important;
          font-weight: 600 !important;
          letter-spacing: 0.02em !important;
          border-color: rgba(255,255,255,0.15) !important;
        }
        .ca-grid-wrap .dx-datagrid-filter-row td {
          background-color: #f5ede4 !important;
        }
        .ca-grid-wrap .dx-datagrid {
          border-radius: 8px !important;
          overflow: hidden !important;
          box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
        }
        .ca-grid-wrap .dx-toolbar {
          background: #fdf7f2 !important;
          border-bottom: 1px solid #e8d5c4 !important;
          padding: 0.35rem 0.6rem !important;
        }
      `}</style>
      <div className="card ca-grid-wrap">
        <div className="card-body">
          <DataGrid
            ref={refDataGrid}
            dataSource={state.nonFlyActivityTransMatrixGridDataSource}
            columnsAutoWidth={false}
            showColumnLines={true}
            showRowLines={true}
            showBorders={true}
            rowAlternationEnabled={false}
            allowColumnResizing={true}
            onCellPrepared={(e) => {
              if (e.rowType === "header") {
                e.cellElement.style.backgroundColor = "#fff0e6";
                e.cellElement.style.color = "#000000";
              }
            }}
            onToolbarPreparing={(e) => {
              e.toolbarOptions.items.unshift({
                location: "after",
                widget: "dxButton",
                options: {
                  icon: "refresh",
                  onClick: async (e) => {
                    e.component.option("icon", "fas fa-spinner fa-spin");
                    await getCrewNonFlyActivityTransMatrixList();
                    e.component.option("icon", "refresh");
                  },
                },
              });
            }}
          >
            <Column
              dataField="rowIndex"
              caption=""
              allowSorting={false}
              allowSearch={false}
              allowExporting={false}
              allowFiltering={false}
              cellRender={renderTransMatrixGridCell}
              fixed={true}
              width={50}
            />
            <Column
              dataField="activityTypeName"
              caption="Activity"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              width={300}
            />
            <Column
              dataField="cockpitCrewTransportAtBase"
              caption="Cockpit Crew Transport At Base"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              width={220}
            />
            <Column
              dataField="cockpitCrewTransportOutsideBase"
              caption="Cockpit Crew Transport Outside Base"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              width={270}
            />
            <Column
              dataField="cabinCrewTransportAtBase"
              caption="Cabin Crew Transport At Base"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              width={220}
            />
            <Column
              dataField="cabinCrewTransportOutsideBase"
              caption="Cabin Crew Transport Outside Base"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              width={270}
            />
            <Column
              dataField="activeStatus"
              caption="Status"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              width={80}
            />
            <Column
              dataField="modifiedDate"
              caption="Date"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              format={DateFormat.DateTime24NorthFormat}
              dataType="datetime"
              width={100}
            />
            <SortByGroupSummaryInfo summaryItem="count" />
            <GroupPanel visible={false} />
            <HeaderFilter visible={true} />
            <SearchPanel
              visible={true}
              highlightCaseSensitive={true}
              width={240}
              placeholder="Search..."
            />
            <Grouping autoExpandAll={true} />
            <Paging defaultPageSize={20} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={[10, 20, 50]}
              showInfo={true}
              visible={true}
            />
            <Export
              enabled={true}
              allowExportSelectedData={false}
              fileName="NonFlyActivityTransMatrix"
            />
          </DataGrid>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={state.openTransMatrixModal}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "40%" } }}
        onAfterClose={async () => {
          let transMatrix = state.transMatrix;
          transMatrix.id = 0;
          transMatrix.activityTypeName = "";
          transMatrix.cockpitCrewTransportAtBase = false;
          transMatrix.cockpitCrewTransportOutsideBase = false;
          transMatrix.cabinCrewTransportAtBase = false;
          transMatrix.cabinCrewTransportOutsideBase = false;
          setState((prev) => ({
            ...prev,
            transMatrix: transMatrix,
          }));
          await getCrewNonFlyActivityTransMatrixList();
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            Transport Matrix For - [{state.transMatrix.activityTypeName}]
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              setState((prev) => ({
                ...prev,
                openTransMatrixModal: false,
              }));
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="form-group">
                <CheckBox
                  value={state.transMatrix.cockpitCrewTransportAtBase}
                  onValueChanged={(e) => {
                    setState((prev) => ({
                      ...prev,
                      transMatrix: {
                        ...state.transMatrix,
                        cockpitCrewTransportAtBase: e.value,
                      },
                    }));
                  }}
                />
                <label htmlFor="cockpitCrewTransportAtBase">
                  &nbsp;&nbsp; Cockpit Crew Transport At Base
                </label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="form-group">
                <CheckBox
                  value={state.transMatrix.cockpitCrewTransportOutsideBase}
                  onValueChanged={(e) => {
                    setState((prev) => ({
                      ...prev,
                      transMatrix: {
                        ...state.transMatrix,
                        cockpitCrewTransportOutsideBase: e.value,
                      },
                    }));
                  }}
                />
                <label htmlFor="cockpitCrewTransportOutsideBase">
                  &nbsp;&nbsp; Cockpit Crew Transport Outside Base
                </label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="form-group">
                <CheckBox
                  value={state.transMatrix.cabinCrewTransportAtBase}
                  onValueChanged={(e) => {
                    setState((prev) => ({
                      ...prev,
                      transMatrix: {
                        ...state.transMatrix,
                        cabinCrewTransportAtBase: e.value,
                      },
                    }));
                  }}
                />
                <label htmlFor="cabinCrewTransportAtBase">
                  &nbsp;&nbsp; Cabin Crew Transport At Base
                </label>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="form-group">
                <CheckBox
                  value={state.transMatrix.cabinCrewTransportOutsideBase}
                  onValueChanged={(e) => {
                    setState((prev) => ({
                      ...prev,
                      transMatrix: {
                        ...state.transMatrix,
                        cabinCrewTransportOutsideBase: e.value,
                      },
                    }));
                  }}
                />
                <label htmlFor="cabinCrewTransportOutsideBase">
                  &nbsp;&nbsp; Cabin Crew Transport Outside Base
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Save"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnSubmitActivityTransMatrix(e);
            }}
          >
            <i
              className={`fas fa-${
                state.isTransMatrixSubmitted ? "spinner fa-spin" : "check"
              }`}
            />
            &nbsp;Update
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              setState((prev) => ({
                ...prev,
                openTransMatrixModal: false,
              }));
            }}
          >
            <span title="Reset">
              <i className="fas fa-times"></i>&nbsp;Close
            </span>
          </button>
        </div>
      </Modal>
      {state.viewActivityCodes.openModal && (
        <ViewActivityCode
          activityTypeId={state.viewActivityCodes.activityTypeId}
          activityTypeName={state.viewActivityCodes.activityTypeName}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              viewActivityCodes: {
                openModal: false,
                activityTypeId: 0,
                activityTypeName: "",
              },
            }));
          }}
        />
      )}
    </>
  );
}

export const ViewActivityCode = memo((props) => {
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "55%" } }}
      >
        <div className="modal-header">
          <h6 className="modal-title">Activity [ {props.activityTypeName} ]</h6>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <CrewActivityCodeComponent activityTypeId={props.activityTypeId} />
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Cancel"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              props.onClose();
            }}
          >
            <span title="Reset">
              <i className="fas fa-times"></i>&nbsp; Close
            </span>
          </button>
        </div>
      </Modal>
    </>
  );
});
